<template>
        <el-dialog
        :title="title"
        :visible.sync="visible"
        width="40%"
    >
        <el-form 
            ref="form"
            label-width="120px"
            :model="form"
            :rules="formRules"
        >
            <el-form-item label="支出时间" prop="ExpendTime">
                <el-date-picker
                    style="width: 250px"
                    v-model="form.ExpendTime"
                    type="datetime"
                    value-format="timestamp"
                    placeholder="选择日期"
            ></el-date-picker>
            </el-form-item>
            <el-form-item label="捐赠者" prop="Name" v-if="expendType === 2">
                <el-input
                    style="width: 250px"
                    placeholder="请输入捐赠者"
                    v-model="form.Name"
                    clearable
                    maxlength="30"
                ></el-input>
            </el-form-item>
            <el-form-item label="物品名称" prop="MaterialsName" v-if="expendType === 2">
                <el-input
                    style="width: 250px"
                    placeholder="请输入物品名称"
                    v-model="form.MaterialsName"
                    clearable
                    maxlength="30"
                ></el-input>
            </el-form-item>
            <el-form-item label="数量" prop="Number" v-if="expendType === 2">
                <el-input
                  type="Number"
                  v-model="form.Number"
                  clearable
                  placeholder="请输入数量"
                ></el-input>
              </el-form-item>
              <el-form-item label="单位" prop="Unit" v-if="expendType === 2">
                <el-input
                  v-model="form.Unit"
                  clearable
                  placeholder="请输入单位"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item label="金额" prop="Amount">
                <el-input
                  type="Number"
                  v-model="form.Amount"
                  clearable
                  placeholder="请输入金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="接收方" prop="ProjectName">
                <el-input
                  v-model="form.ProjectName"
                  clearable
                  placeholder="请输入接收方"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            <el-form-item label="支出详情" >
                <el-input type="textarea" placeholder="请输入支出详情" v-model="form.Remark" maxlength="200" show-word-limit :rows="6"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import api from "@/modules/zjrc/api";
export default {
    data () {
        return {
            form: {},
            title: '',
            visible: false,
            formRules: {
                ExpendTime: {
                    required: true,
                    message: "请输入支出时间",
                    trigger: "blur",
                },
                Name: {
                    required: true,
                    message: "请输入捐赠者",
                    trigger: "blur",
                },
                MaterialsName: {
                    required: true,
                    message: "请输入物品名称",
                    trigger: "blur",
                },
                Number: {
                    required: true,
                    message: "请输入数量",
                    trigger: "blur",
                },
                Unit: {
                    required: true,
                    message: "请输入单位",
                    trigger: "blur",
                },
                Amount: {
                    required: true,
                    message: "请输入金额",
                    trigger: "blur",
                },
                ProjectName: {
                    required: true,
                    message: "请输入接收方",
                    trigger: "blur",
                }
            },
            expendType: 0
        }
    },
    methods: {
        create(record, expendType) {
            const vm = this
            vm.expendType = expendType
            if (!record) {
                vm.title = '新增支出'
            } else {
                vm.title = '编辑支出'
                const param = {
                    id: record.Id
                }
                api.ExpendDetail(param).then(res => {
                    if (res.data.Code === 0) {
                        let form = Object.assign({}, res.data.Data)
                        if (form.ExpendTime) {
                            form.ExpendTime = form.ExpendTime * 1000
                        }
                        vm.form = form
                    }
                })
                .finally(() => {
                    vm.isLoading = false
                })
            }

            vm.visible = true
        },
        submit() {
            const vm = this
            vm.$refs.form.validate(valid => {
                if (valid) {
                    const param = Object.assign({}, vm.form)
                    param.ExpendTime = param.ExpendTime / 1000
                    param.ExpendType = vm.expendType
                    api.SaveExpend(param).then(res => {
                        if (res.data.Code === 0) {
                            this.$message({
                                message: "提交成功",
                                type: "success",
                            });
                            vm.onClose()
                            vm.$emit('onOk')
                        } else {
                            this.$message({
                                message: res.data.Message,
                                type: "error",
                            });
                        }
                    })
                }
            })
        },
        onClose() {
            const vm = this
            vm.visible = false
            vm.$refs.form.resetFields()
            vm.title = ''
            vm.form = {}
            vm.expendType = 0
        }
    }
}
</script>
<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none!important;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
</style>